import React from "react";
import styled from "styled-components";

const FormText = ({ children, bold, ...props }) => {
  return (
    <Text $bold={bold} {...props}>
      {children}
    </Text>
  );
};

const Text = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: var(--aia-bx-black);
  font-weight: ${props => props.$bold ? `bold` : "400"};
`;

Text.defaultProps = {
  $bold: false
};

export default FormText;